<script lang="ts">
    export let data: Record<string, any>
</script>

<div class="block-preview">
    <textarea class="preview-textarea" rows="3" disabled placeholder="Sua resposta" />
</div>

<style>
    .block-preview {
        width: 100%;
        max-width: 560px;
    }
    .preview-textarea {
        width: 100%;
        border: none;
        border-bottom: 1px solid #ced4da;
        background: transparent !important;
        padding: 6px 2px;
        font-size: 0.9rem;
        color: #868e96;
        resize: none;
    }
</style>
